<template lang="pug">
v-app
  section
    header.d-flex.row.flex-row.align-items-end.mb-3
      .col-12
        h1
          i Excepcion planificacion semanal
      .col-2.text-center
        .ad_select.w-100
          select(v-model="year", @change='changeYear($event)')
            option(:value="null" disabled) Selecciona Año
            option(:value="n" v-for="n in years") {{n}}
    section
      .d-flex.row.flex-row.align-items-start.mt-4
        .col-12
          .card.p-0.ad_border2-primaryLight.rounded-xl
            .card-body
              table.w-100.table-order-less_style
                thead
                  tr
                    th
                      | Número de semana
                    th
                      | Día de cierre
                    th(colspan="2")
                tbody
                  tr(v-for="exception in exceptions")
                    td
                      div
                        |  {{ exception.weekNumber }} 
                    td
                      div
                        | {{ moment().locale('es').isoWeekday(exception.weekDay).format('dddd') }}
                    td.text-right
                      div
                        a.btn.btn-secondary.px-3(@click="openModal({id: exception._id, week: exception.weekNumber, day: exception.weekDay})")
                          | Actualizar
                    td.text-right.pr-3
                      div
                        a.btn.btn-danger.text-white.px-3(@click="erase(exception._id)")
                          | Eliminar
      .d-flex.row.flex-row.mt-4
        .col-12.text-right
          button.btn.btn-primary.py-2.px-5(@click="openModal('isNew')")
            em Nueva excepcion

  v-navigation-drawer(v-model='drawer', app='', temporary='', right='', width='500')
    header.ad_bg-primary.pt-5.pb-2.px-4
      h3.text-white.mt-4
        i {{ isNew ? "Nueva" : "Modificar" }} excepcion
    section.py-4.px-2.overflowy-auto
      .col-12.mt-4
        .ad_select.ad_border1-primary
          select(v-model='weekNumber', :disabled="!isNew")
            option(:value="null" disabled) Selecciona numero de semana
            option(:value="numero", v-for="numero in 52") {{numero}}
        br
        .ad_select.ad_border1-primary
          select(v-model='dayOfWeek')
            option(:value="null" disabled) Selecciona dia de la semana
            option(:value="weekDay.number", v-for="weekDay in daysOfWeek") {{weekDay.name}}      
        br  
        .form-group.justify-content-between
          button.btn.btn-secondary-border.py-2.pl-2.pr-3.font-1em(@click="drawer = false")
            i.far.fa-times-circle.fa-1x.mr-1.align-bottom
            | Cancelar
          button.btn.btn-secondary.py-2.pr-2.pl-3.font-1em(@click="isNew ? create() : update()")
            | {{ isNew ? "Crear" : "Actualizar" }} excepcion
            i.fas.fa-chevron-right.fa-1x.ml-2.align-bottom
                        
            
</template>

<script>
import { mapActions } from 'vuex';
import moment from 'moment'


export default {
  name: 'ExcepcionCierrePlanificacion',
  data () {
    return {
      exceptions: [],
      daysOfWeek: [
        {name: "Lunes", number : 1},
        {name: "Martes", number : 2},
        {name: "Miercoles", number : 3},
        {name: "Jueves", number : 4},
        {name: "Viernes", number : 5},
      ],
      drawer: false,
      dayOfWeek: null,
      weekNumber: null,
      isNew: null,
      exceptionId: null,
      year: null,
      years: []
    }
  },
  methods: {
    moment,
    ...mapActions('schedule', [
      'getExceptions',
      'createException',
      'updateException',
      'deleteException',
      'getExceptionsByYear'
    ]),
    update() {
      const vm = this;
      const loading = vm.$toast.loading('Cargando...')
      if (vm.dayOfWeek || vm.weekNumber) {
        const data = {
          _id: vm.exceptionId, weekNumber: +vm.weekNumber, weekDay: +vm.dayOfWeek
        }
        vm.updateException(data).then((updatedSche) => {
          vm.exceptions = vm.$store.getters['schedule/getExceptions']
          vm.weekNumber = null
          vm.dayOfWeek = null
          loading.hide()
          vm.$notify({
            type: 'success',
            title: 'Notificación',
            content: 'Excepcion actualizada',
            closeable: true,
            duration: 5000
          })
          vm.drawer = false
        })
      } else {
        loading.hide()
        vm.$notify({
          type: 'danger',
          title: 'Notificación',
          content: 'Debe elegir dia y numero de semana',
          closeable: true,
          duration: 5000
        })
      }    
    },
    create() {
      const vm = this;
      const loading = vm.$toast.loading('Cargando...')
      if (vm.dayOfWeek || vm.weekNumber) {
        const data = {
          weekNumber: +vm.weekNumber, weekDay: +vm.dayOfWeek
        }
        vm.createException(data).then(() => {
          vm.schedules = vm.$store.getters['schedule/getExceptions']
          vm.exceptions.push(vm.schedules)
          vm.weekNumber = null
          vm.dayOfWeek = null
          loading.hide();
          vm.$notify({
            type: 'success',
            title: 'Notificación',
            content: 'Excepcion creada',
            closeable: true,
            duration: 5000
          })
          vm.drawer = false
        })
      } else {
        loading.hide();
        vm.$notify({
          type: 'danger',
          title: 'Notificación',
          content: 'Debe elegir dia y numero de semana',
          closeable: true,
          duration: 5000
        })
      }
    },
    erase(id) {
      const vm =this;
      const loading = vm.$toast.loading('Cargando...')
      vm.deleteException(id).then(() => {
        vm.schedules = vm.$store.getters['schedule/getExceptions']
        loading.hide();
        vm.$notify({
          type: 'success',
          title: 'Notificación',
          content: 'Excepcion eliminada',
          closeable: true,
          duration: 5000
        })
      })
    },
    openModal(type) {
      const vm = this;
      if (type == "isNew") {
        vm.isNew = true
      } else {
        vm.isNew = false
        vm.weekNumber = +type.week
        vm.dayOfWeek = +type.day
        vm.exceptionId = type.id
      }
      vm.drawer = true
    },
    changeYear($event) {
      this.$nextTick(() => {
        const vm = this;
        const loading = vm.$toast.loading('Cargando...')
        vm.getExceptionsByYear(vm.year).then(exceptions => {
          vm.exceptions = exceptions
          loading.hide();
        }, (error) => {
          loading.hide();
          vm.$notify({
            type: 'error',
            title: 'Notificación',
            content: error,
            closeable: true,
            duration: 5000
          })
        });
      })
    },
    getYears() {
      const vm = this;
      let currentYear = new Date().getFullYear();
      let startYear = 2019;
      let yearslist = [];  
      while ( startYear <= currentYear ) {
          yearslist.push(startYear++);
      }   
      vm.years = yearslist;
    }
  },
  mounted() {
    const vm = this;
    const loading = vm.$toast.loading('Cargando...')
    vm.year = new Date().getFullYear();
    vm.getYears();
    vm.getExceptionsByYear(vm.year).then(exceptions => {
      vm.exceptions = exceptions
      loading.hide();
    }, (error) => {
      loading.hide();
      vm.$notify({
        type: 'error',
        title: 'Notificación',
        content: error,
        closeable: true,
        duration: 5000
      })
    });
  }

}
</script>

<style lang="stylus" scoped>
ul
  display flex
  margin 0
  padding 0
  align-items center
  justify-content space-between
  li
    display flex
</style>


// WEBPACK FOOTER //
// src/views/cierre-planificacion.vue